module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/283.a3988c4c.png";